import { IonBadge, IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonReorder, IonReorderGroup, IonRow, IonTitle, IonToast, IonToolbar, isPlatform, ItemReorderEventDetail, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { add, arrowBack, pencil, reorderTwo, trash } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { alterarStatusVendaEmpresa, empresaCarregar, inserirStatusVendaEmpresa, ordernarStatusVendaEmpresa, removerStatusVendaEmpresa, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./EmpresaWorkflowVendaCadastro.css";

type Props = {
  abrirMenu: boolean;
  onDismiss: () => void;
};

export interface Opcao {
  descricao: string;
}

const EmpresaWorkflowVendaCadastro: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [configWorkflowVenda, setConfigWorkflowVenda] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [indice, setIndice] = useState("");
  const [status, setStatus] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const isWeb = isPlatform('desktop');
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [mostartAlerta] = useIonAlert();

  const inputRef = useRef<any>(null);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
  });


  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setConfigWorkflowVenda(response.Item.configWorkflowVenda || []);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }



  function deletarStatus(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delStatus = async () => {
      const resp = await fetch(removerStatusVendaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerStatusVendaEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'indice': indice }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Item removido com sucesso.");
        setShowToast(true);
        setConfigWorkflowVenda(retorno.Item?.Attributes?.configWorkflowVenda || []);
        window.localStorage.setItem("configWorkflowVenda", JSON.stringify(retorno.Item?.Attributes?.configWorkflowVenda));
      }
      else {
        setTextToast("Ocorreu um erro ao efetuar a exclusão.");
        setShowToast(true);
      }
    }

    delStatus();

  }


  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    // Before complete is called with the items they will remain in the
    // order before the drag
    // console.log('Before complete', configWorkflowVenda);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setConfigWorkflowVenda(event.detail.complete(configWorkflowVenda));

    // After complete is called the items will be in the new order
    // console.log('After complete', configWorkflowVenda);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordStatus = async () => {
      const resp = await fetch(ordernarStatusVendaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarStatusVendaEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'configWorkflowVenda': configWorkflowVenda }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setConfigWorkflowVenda(retorno.Item?.Attributes?.configWorkflowVenda || []);
        window.localStorage.setItem("configWorkflowVenda", JSON.stringify(retorno.Item?.Attributes?.configWorkflowVenda));
      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordStatus();

  }


  const loadStatus = () => {

    if (configWorkflowVenda == undefined) return;

    if (configWorkflowVenda.length === 0) {
      return (
        <>
          <IonItem lines="none">

            <IonLabel>
              <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum item cadastrado</strong></h2>
            </IonLabel>

          </IonItem>
        </>

      );
    }


    return (
      <>
        {/* The reorder gesture is disabled by default, enable it to drag and drop items */}
        <IonReorderGroup disabled={isDisabled} onIonItemReorder={handleReorder}>
          {configWorkflowVenda.map((value: any, index: any) => (
            <IonItem style={{ '--background': value.bgColor }} lines="none" key={"config" + index}>

              <IonLabel >{value.status}</IonLabel>
              {/* <IonLabel >{value.bgColor}</IonLabel> */}
              <IonLabel></IonLabel>


              <div style={{ position: "absolute", right: "10px", zIndex: 9999999, backgroundColor: value.bgColor, textAlign: "right" }}>
                <IonReorder slot="end"></IonReorder>
              </div>
              <div style={{ position: "absolute", right: "6px", zIndex: 9999999, backgroundColor: value.bgColor, textAlign: "right" }}>
                <IonButtons >





                  <IonButton hidden={!isDisabled || acessos?.configuracoes != 'edicao'}
                    onClick={() => {
                      setIndice(value.indice);
                      setStatus(value.status);
                      setBgColor(value.bgColor);

                      setShowDetalhes(true);

                    }}>
                    <IonIcon color="primary" icon={pencil} />
                  </IonButton>

                  <IonButton hidden={!isDisabled || acessos?.configuracoes != 'edicao'}
                    onClick={() => {
                      mostartAlerta({
                        backdropDismiss: false,
                        header: 'Remover item',
                        message: 'Deseja <strong>remover</strong>?',
                        buttons: [
                          {
                            text: 'Cancelar',
                            role: 'cancel',
                          },
                          {
                            text: 'Confirmar',
                            cssClass: 'primary',
                            handler: () => {
                              deletarStatus(value.indice);
                            }
                          }
                        ],
                        onDidDismiss: (e) => console.log('did dismiss'),
                      })
                    }}>
                    <IonIcon color="primary" icon={trash} />
                  </IonButton>

                </IonButtons>

              </div>
            </IonItem>

          ))}
        </IonReorderGroup>
      </>
    );
  }

  function cadastrar() {
    if (!status || status.trim() == ""
      || !bgColor || bgColor.trim() == "") {
      setTextToast("Todos os campos são obrigatórios.");
      setShowToast(true);
      return false;
    }
    else {



      console.log("indice", indice);
      if (indice != "") {
        const objectRequest = {
          status: status,
          bgColor: bgColor,
          indice: indice
        }
        console.log("objectRequest", objectRequest);

        let id = loja;

        console.log("id", id);

        requestService(
          alterarStatusVendaEmpresa.url.replace("{id}", id.replaceAll("#", "%23")),
          {
            method: alterarStatusVendaEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              setTextToast("Alteração realizada com sucesso.");
              setShowToast(true);

              setConfigWorkflowVenda(response.message.Attributes.configWorkflowVenda || []);
              window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.message.Attributes.configWorkflowVenda));
              setShowDetalhes(false);

            } else if (response.status === 400) {
              console.log(response);
              setTextToast("Ocorreu um erro ao efetuar a alteração.");
              setShowToast(true);

            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            setTextToast("Ocorreu um erro ao efetuar a alteração.");
            setShowToast(true);
            setShowLoading(false);
          })
      } else {
        const objectRequest = {
          status: status,
          bgColor: bgColor
        }
        console.log("objectRequest", objectRequest);

        let id = loja;

        console.log("id", id);

        requestService(
          inserirStatusVendaEmpresa.url.replace("{id}", id.replaceAll("#", "%23")),
          {
            method: inserirStatusVendaEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              setTextToast("Cadastro realizado com sucesso.");
              setShowToast(true);

              setConfigWorkflowVenda(response.message.Attributes.configWorkflowVenda || []);
              window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.message.Attributes.configWorkflowVenda));
              setShowDetalhes(false);

            } else if (response.status === 400) {
              console.log(response);
              setTextToast("Ocorreu um erro ao efetuar o cadastro.");
              setShowToast(true);

            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            setTextToast("Ocorreu um erro ao efetuar o cadastro.");
            setShowToast(true);
            setShowLoading(false);
          })
      }
    }

  }

  return (

    <IonPage className="EmpresaWorkflowVendaCadastro">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Configurações Funil</IonTitle>
        </IonToolbar>
        {isWeb && (
          <IonToolbar hidden={acessos?.configuracoes != 'edicao'}>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 8px 0 8px" }}>
              <IonButton
                fill="solid"
                size="large"
                color="tertiary"
                onClick={() => {
                  setIndice("");
                  setStatus("");
                  setBgColor("");
                  setShowDetalhes(true);
                }}>
                <IonIcon slot="start" icon={add} />
                Novo status
              </IonButton>
            </div>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent fullscreen={false}>
        {!isWeb && (
          <IonFab vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}>
            <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => {
              setIndice("");
              setStatus("");
              setBgColor("");
              setShowDetalhes(true);
            }} >
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}



        <IonList>
          <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>

            <IonLabel style={{ fontSize: "12px" }}>Status</IonLabel>
            {/* <IonLabel style={{ fontSize: "12px" }}>Cor</IonLabel> */}
            <IonLabel style={{ textAlign: "right" }}>
              <IonBadge hidden={acessos?.configuracoes != 'edicao'}
                onClick={() => setIsDisabled((current) => !current)}>
                <IonIcon color="medium" icon={reorderTwo}></IonIcon>
              </IonBadge>
            </IonLabel>
          </IonItem>
          {loadStatus()}



          {/* <IonFab horizontal="end" edge style={{ "top": "0px", "right": "-4px" }} hidden={acessos?.configuracoes != 'edicao'}>
            <IonFabButton size="small" color="tertiary" 
              <IonIcon color="light" icon={menu}></IonIcon>
            </IonFabButton>
          </IonFab> */}
        </IonList>


        {/* <IonButton slot="end" >Ordenar</IonButton> */}



        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
        }}>


          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>Novo item</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonList>

                      <IonItem lines="none">
                        <IonLabel>Status*</IonLabel>
                        <IonInput placeholder="Digite o status" value={status} ref={(ref) => inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setStatus(e.target.value)}></IonInput>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>Cor*</IonLabel>

                      </IonItem>

                      <IonItem lines="none">
                        <IonGrid>
                          <IonRow>
                            <IonCol style={{ "background": "#FF6666" }} onClick={() => { setBgColor("#FF6666"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFB266" }} onClick={() => { setBgColor("#FFB266"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFFF66" }} onClick={() => { setBgColor("#FFFF66"); }}> </IonCol>
                            <IonCol style={{ "background": "#B2FF66" }} onClick={() => { setBgColor("#B2FF66"); }}> </IonCol>
                            <IonCol style={{ "background": "#66FF66" }} onClick={() => { setBgColor("#66FF66"); }}> </IonCol>
                            <IonCol style={{ "background": "#66FFB2" }} onClick={() => { setBgColor("#66FFB2"); }}> </IonCol>
                            <IonCol style={{ "background": "#66FFFF" }} onClick={() => { setBgColor("#66FFFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#66B2FF" }} onClick={() => { setBgColor("#66B2FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#6666FF" }} onClick={() => { setBgColor("#6666FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#B266FF" }} onClick={() => { setBgColor("#B266FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FF66FF" }} onClick={() => { setBgColor("#FF66FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FF66B2" }} onClick={() => { setBgColor("#FF66B2"); }}> </IonCol>
                            <IonCol style={{ "background": "#C0C0C0" }} onClick={() => { setBgColor("#C0C0C0"); }}> </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol style={{ "background": "#FF9999" }} onClick={() => { setBgColor("#FF9999"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFCC99" }} onClick={() => { setBgColor("#FFCC99"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFFF99" }} onClick={() => { setBgColor("#FFFF99"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCFF99" }} onClick={() => { setBgColor("#CCFF99"); }}> </IonCol>
                            <IonCol style={{ "background": "#99FF99" }} onClick={() => { setBgColor("#99FF99"); }}> </IonCol>
                            <IonCol style={{ "background": "#99FFCC" }} onClick={() => { setBgColor("#99FFCC"); }}> </IonCol>
                            <IonCol style={{ "background": "#99FFFF" }} onClick={() => { setBgColor("#99FFFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#99CCFF" }} onClick={() => { setBgColor("#99CCFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#9999FF" }} onClick={() => { setBgColor("#9999FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#CC99FF" }} onClick={() => { setBgColor("#CC99FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FF99FF" }} onClick={() => { setBgColor("#FF99FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FF99CC" }} onClick={() => { setBgColor("#FF99CC"); }}> </IonCol>
                            <IonCol style={{ "background": "#E0E0E0" }} onClick={() => { setBgColor("#E0E0E0"); }}> </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol style={{ "background": "#FFCCCC" }} onClick={() => { setBgColor("#FFCCCC"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFE5CC" }} onClick={() => { setBgColor("#FFE5CC"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFFFCC" }} onClick={() => { setBgColor("#FFFFCC"); }}> </IonCol>
                            <IonCol style={{ "background": "#E5FFCC" }} onClick={() => { setBgColor("#E5FFCC"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCFFCC" }} onClick={() => { setBgColor("#CCFFCC"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCFFE5" }} onClick={() => { setBgColor("#CCFFE5"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCFFFF" }} onClick={() => { setBgColor("#CCFFFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCE5FF" }} onClick={() => { setBgColor("#CCE5FF"); }}> </IonCol>
                            <IonCol style={{ "background": "#CCCCFF" }} onClick={() => { setBgColor("#CCCCFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#E5CCFF" }} onClick={() => { setBgColor("#E5CCFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFCCFF" }} onClick={() => { setBgColor("#FFCCFF"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFCCE5" }} onClick={() => { setBgColor("#FFCCE5"); }}> </IonCol>
                            <IonCol style={{ "background": "#FFFFFF" }} onClick={() => { setBgColor("#FFFFFF"); }}> </IonCol>
                          </IonRow>

                        </IonGrid>
                      </IonItem>

                      <IonItem lines="none">

                        <IonGrid>
                          <IonRow>
                            <IonCol style={{ "background": bgColor }}> </IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonItem>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonGrid>

            </IonContent>
            <IonFooter className="ion-no-border">
              <IonToolbar>
                <IonButton onClick={() => cadastrar()} expand="block" type="submit">Cadastrar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default EmpresaWorkflowVendaCadastro;